import { render, staticRenderFns } from "./ProgramView.vue?vue&type=template&id=6e56b99e&scoped=true"
import script from "./ProgramView.vue?vue&type=script&lang=js"
export * from "./ProgramView.vue?vue&type=script&lang=js"
import style0 from "./ProgramView.vue?vue&type=style&index=0&id=6e56b99e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e56b99e",
  null
  
)

export default component.exports